export default __webpack_public_path__ + "static/pillars-technology-c3681b8644b9a5e1109aa6b7761ff22b.png";